<template>
  <div class="diy-sidebar__menu">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TheSidebarMenuLayout',
}
</script>

<style scoped>
.diy-sidebar__menu {
  display: grid;
  gap: 10px;
  position: relative;
  overflow: hidden;
}

@media (max-width: 680px) {
  .diy-sidebar__menu {
    grid-auto-columns: auto;
    grid-auto-flow: column;
    align-items: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding: 0;
  }
}
</style>
